import {
    objectNode,
    type ObjectNode, type ObjectProperties,
    updateObject,
} from '@/lib/threeScene/nodes/object';
import { AxesHelper } from 'three';
import { stopAll, type StopHandle } from '@/util';
import type { SceneContext } from '@/lib/threeScene/SceneContext';
import type { NodeId } from '@/lib/threeScene/nodeId';

export type AxesNode = ObjectNode<'axes'>;

export function axesNode(id: NodeId, properties?: ObjectProperties<AxesNode>): AxesNode {
    return objectNode('axes', id, properties);
}

const AXES_HELPER_SIZE = 20;

export function updateAxes(context: SceneContext, node: AxesNode): StopHandle {
    const axes = new AxesHelper(AXES_HELPER_SIZE)
    return stopAll(
        updateObject(context, node, axes),
        () => axes.dispose(),
    );
}
